module.exports = {
  id: 'pressForm',
  method: 'post',
  action: `${process.env.JSON_API_HOST}/actions/futurium/forms/add-to-press-distributor`,
  cells: [
    {
      modifier: 'half',
      fieldType: 'input',
      name: 'medium',
      label: 'Medium',
      placeholder: 'Medium',
      required: true
    },
    {
      modifier: 'half',
      fieldType: 'input',
      name: 'mediumType',
      label: 'Gattung',
      placeholder: 'Gattung'
    },
    {
      fieldType: 'input',
      modifier: 'half',
      name: 'department',
      label: 'Ressort',
      placeholder: 'Ressort'
    },
    {
      fieldType: 'select',
      modifier: 'half',
      name: 'salutation',
      label: 'Anrede',
      required: true,
      options: [
        {
          value: 'female',
          text: 'Frau'
        },
        {
          value: 'male',
          text: 'Herr'
        }
      ]
    },
    {
      fieldType: 'input',
      modifier: 'half',
      name: 'position',
      label: 'Position',
      placeholder: 'Position',
      autocomplete: 'organization-title',
      required: true
    },
    {
      fieldType: 'input',
      modifier: 'half',
      name: 'title',
      label: 'Titel',
      placeholder: 'Titel'
    },
    {
      modifier: 'half',
      fieldType: 'input',
      name: 'firstName',
      label: 'Vorname',
      placeholder: 'Vorname',
      autocomplete: 'given-name',
      required: true
    },
    {
      modifier: 'half',
      fieldType: 'input',
      name: 'lastName',
      label: 'Nachname',
      placeholder: 'Nachname',
      autocomplete: 'family-name',
      required: true
    },
    {
      modifier: 'half',
      fieldType: 'input',
      name: 'email',
      type: 'email',
      label: 'E-Mail',
      placeholder: 'E-Mail',
      autocomplete: 'email',
      required: true
    },
    {
      id: 2,
      modifier: 'half',
      fieldType: 'input',
      name: 'tel',
      label: 'Telefon',
      placeholder: 'Telefon',
      autocomplete: 'tel'
    },
    {
      modifier: 'half',
      fieldType: 'input',
      name: 'street',
      label: 'Straße',
      placeholder: 'Straße'
    },
    {
      modifier: 'half',
      fieldType: 'input',
      name: 'houseNo',
      label: 'Hausnummer',
      placeholder: 'Hausnummer'
    },
    {
      modifier: 'half',
      fieldType: 'input',
      name: 'zipCode',
      label: 'PLZ',
      placeholder: 'PLZ'
    },
    {
      modifier: 'half',
      fieldType: 'input',
      name: 'city',
      label: 'Ort',
      placeholder: 'Ort',
      autocomplete: 'postal-code'
    },
    {
      fieldType: 'input',
      name: 'country',
      label: 'Land',
      placeholder: 'Land',
      autocomplete: 'country-name'
    },
    {
      fieldType: 'textarea',
      name: 'comments',
      label: 'Bemerkungen',
      placeholder: 'Bemerkungen'
    }
  ],
  submitText: 'Sign in'
};
